import { getUSDTransform } from './getUSDTransform';

const MAX_VALUE = 1000000000;
const MAX_DECIMALS_LENGTH = 2;

export const estCostBasisTransform = getUSDTransform({
  maxValue: MAX_VALUE,
  maxDecimalsLength: MAX_DECIMALS_LENGTH,
});
